var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import moment from 'moment';

import { config } from '../config/apiConfig';
import { STORAGE_TYPES } from './types/storage.types';
import { GLOBAL_TYPES } from './types/global.types';
import { load as storageLoad, save as storageSave, init as storageInit } from './storage';
import { DATE_DETAILS_FORMAT } from '../constants/data.constant';
import { dateToTst, tstToMomentDate } from '../utils/helpers';
import { COST_MODE } from '../services/core/cost/cost.constant';

let defaultKey;

//region API

export const init = (cbSuccess, key) => {
    defaultKey = key;
    storageInit();
    const cbFail = () => {
        clear();
        cbSuccess(getInitialState());
    };

    storageLoad(defaultKey, cbSuccess, cbFail);
};

export const get = () => {
    const cbFail = error => {
        clear();
    };

    return storageLoad(defaultKey, null, cbFail);
};

export const save = (() => {
    var _ref = _asyncToGenerator(function* (data) {
        let dataFromStorage = null;
        try {
            dataFromStorage = yield get();
            return storageSave(defaultKey, _extends({}, dataFromStorage, data));
        } catch (error) {
            switch (error.name) {
                case STORAGE_TYPES.ERROR_NOT_FOUND:
                case STORAGE_TYPES.ERROR_EXPIRED:
                    return storageSave(defaultKey, data);
                    break;
                default:
                    throw error;
            }
        }
    });

    return function save(_x) {
        return _ref.apply(this, arguments);
    };
})();

//endregion

//region custom API

export const clearLogout = () => {
    saveLastVisitDate();
};

export const clear = () => {
    storageSave(defaultKey, getInitialState());
};

export const getInitialState = () => {
    const settings = {
        [GLOBAL_TYPES.LAST_VISIT_TIME]: tstToMomentDate(dateToTst(new Date()), DATE_DETAILS_FORMAT),
        [GLOBAL_TYPES.COST_MODE]: COST_MODE.WATT
    };

    if (process.env.IS_WEB) {
        settings[GLOBAL_TYPES.SERVER_IP] = config.IOT_SERVER_IP_WEB;
        settings[GLOBAL_TYPES.SERVER_PORT] = config.IOT_SERVER_PORT_WEB;
    } else {
        settings[GLOBAL_TYPES.SERVER_IP] = config.IOT_SERVER_IP_MOBILE;
        settings[GLOBAL_TYPES.SERVER_PORT] = config.IOT_SERVER_PORT_MOBILE;
    }

    return settings;
};

export const getLastVisitDate = settings => {
    const dateStr = settings[GLOBAL_TYPES.LAST_VISIT_TIME];
    if (!dateStr) {
        return new Date();
    }

    const date = moment(dateStr, DATE_DETAILS_FORMAT).toDate();
    return date;
};

export const saveLastVisitDate = () => {
    const date = tstToMomentDate(dateToTst(new Date()), DATE_DETAILS_FORMAT);
    save({ [GLOBAL_TYPES.LAST_VISIT_TIME]: date });
    return date;
};

// export const getCostMode = async() => {
//     const settings = await get();
//     if (settings) {
//         return settings[GLOBAL_TYPES.COST_MODE];
//     }
//
//     return saveCostMode(COST_MODE.WATT);
// };
//
// export const saveCostMode = (value) => {
//     save({ [GLOBAL_TYPES.COST_MODE]: value });
//     return value;
// };

export const getServerUrl = (() => {
    var _ref2 = _asyncToGenerator(function* () {
        const settings = yield get();
        const http = 'http://';
        let url = null;

        if (settings) {
            url = http + settings[GLOBAL_TYPES.SERVER_IP] + ':' + settings[GLOBAL_TYPES.SERVER_PORT] + '/' + config.IOT_REST_SERVER_PREFIX + '/';
        } else {
            const serverAddress = process.env.IS_WEB ? config.IOT_SERVER_IP_WEB + ':' + config.IOT_SERVER_PORT_WEB : config.IOT_SERVER_IP_MOBILE + ':' + config.IOT_SERVER_PORT_MOBILE;

            url = http + serverAddress + '/' + config.IOT_REST_SERVER_PREFIX + '/';
        }

        return url;
    });

    return function getServerUrl() {
        return _ref2.apply(this, arguments);
    };
})();

//endregion


// WEBPACK FOOTER //
// ./~/pluton-core/lib/device/settings.storage.js